import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../components/InfoTooltip';

import {
  createBanner,
  createContactInfo,
  createShellySettings,
  deleteUploads,
  getBanner,
  getContactInfo,
  getShellySettings,
  uploadFile,
} from '../helper/backend_helper';
import appConfig from '../config';

// import logo from 'src/components/logo';

const ShellySetting = () => {
  const [shellySettingsData, setShellySettingsData] = useState({});

  const [deviceAuthToken, setDeviceAuthToken] = useState('');
  const [baseUrl, setBaseUrl] = useState('');


  const [loading, setLoading] = useState(false);
 

  const Banner = async () => {
    try {
      const bannerResponse = await getShellySettings();
      setShellySettingsData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setDeviceAuthToken(shellySettingsData?.deviceAuthToken || '');
    setBaseUrl(shellySettingsData?.baseUrl || '');
  }, [shellySettingsData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (deviceAuthToken.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Device Token cannot be empty',
        });
        setLoading(false);
        return;
      }

      if (baseUrl.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Base URL cannot be empty',
        });
        setLoading(false);
        return;
      }
   


     
      const BannerData = {
        deviceAuthToken,
        baseUrl:baseUrl.trim(),
       
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createShellySettings(BannerData, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Shelly Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Shelly Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Shelly Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">
            Shelly Settings{' '}
            <InfoTooltip
              width={20}
              title="The Shelly Cloud connection used to control the property's smart relay devices, such as door openers and switches. It holds the device authorization token and the regional API base URL that every device request is sent through. Enter these values here and Update so the system can sync and operate your Shelly devices."
            />
          </Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '60ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Auth Token <InfoTooltip title="Shelly Cloud device authorization token used to authenticate API calls that control your relay devices." /></FormLabel>
              <TextField
              multiline
              minRows={3}
                label="Enter Auth Token"
                id="outlined-size-small"
                value={deviceAuthToken}
                onChange={(e) => setDeviceAuthToken(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Base Url <InfoTooltip title="Base URL of your Shelly Cloud API region (e.g. the server endpoint all device requests are sent to)." /></FormLabel>
              <TextField
                label="Enter Base Url"
                id="outlined-size-small"
                value={baseUrl}
                onChange={(e) => setBaseUrl(e.target.value)}
              />
            </Stack>
          </Stack>
        
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default ShellySetting;
